import React from 'react';
import "./card.css";
import { ReactComponent as IconSvg } from "./icon-fast.svg";
import Modal from '../../modal';

class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        };
    }

    openModal = () => {
        this.setState({ isModalOpen: true });
    };

    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    render() {
        const cardContent = (
            <div className="card">
                <IconSvg className="card-logo" />
                <p className="card-text">{this.props.text}</p>
            </div>
        );

        // If link prop is provided, render as anchor tag
        if (this.props.link) {
            return (
                <a 
                    href={this.props.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="card-wrapper card-clickable card-link"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {cardContent}
                </a>
            );
        }

        // Otherwise, render as clickable div for modal or non-interactive
        return (
            <>
                <div 
                    className={`card-wrapper ${this.props.modalContent ? 'card-clickable' : ''}`}
                    onClick={this.props.modalContent ? this.openModal : undefined}
                >
                    {cardContent}
                </div>
                
                {this.props.modalContent && (
                    <Modal 
                        isOpen={this.state.isModalOpen} 
                        onClose={this.closeModal}
                    >
                        {this.props.modalContent}
                    </Modal>
                )}
            </>
        );
    }
}

export default Card;